module.exports = __webpack_public_path__ + "img/00502788_nhiet_ke_hong_ngoai_do_tran_microlife_nc200_7708_6391_large_84c0ed9d82.aaeae6fe.webp";